import * as chartActionTypes from '../constants/chart-action-types';
import ChartService from '../util/ChartService';
import { japaneseCharacterCheck } from '../util/japaneseCharFinder';
import SvgToBlob from '../util/SvgToBlob';
import { getChartCssPath } from './publish-actions/publish-actions.utils';
import { hasVideo } from '../util/cropsUtil';

function destroyChart() {
  return { type: chartActionTypes.DESTROY_CHART };
}

function requestChart(id) {
  return { type: chartActionTypes.REQUEST_CHART, id };
}

function receiveChart(error, data, appRoles = []) {
  return { type: chartActionTypes.RECEIVE_CHART, error, data, appRoles };
}

function createChartCompleteDuplicate(error, data, isDuplicate, id) {
  return { type: chartActionTypes.CREATE_CHART_COMPLETE_DUPLICATE, error, data, isDuplicate, id };
}

function createChartComplete(error, data) {
  return { type: chartActionTypes.CREATE_CHART_COMPLETE, error, data };
}

function deleteChart(error, data) {
  return { type: chartActionTypes.DELETE_CHART, error, data };
}

function updateChartComplete(error, data) {
  return { type: chartActionTypes.UPDATE_CHART_COMPLETE, error, data };
}

function createChart() {
  return { type: chartActionTypes.CREATE_CHART };
}

function importChart(chart) {
  return { type: chartActionTypes.IMPORT_CHART, chart };
}

function saveBlob({ blob, filename }) {
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.setAttribute('download', filename);
  a.click(); // TODO: review moving to effect, outside actions
}

// Publishing
function approveChart(category, value) {
  return { type: chartActionTypes.APPROVE_CHART, category, value };
}

function download(svgStr, publication, id, size, idx, accessToken, language) {
  const isVideo = hasVideo(size.id);
  const chartCssPath = getChartCssPath(publication, isVideo);
  ChartService.downloadPng(accessToken, publication, svgStr, chartCssPath, language)
    .then((blob) => {
      const isValidBuffer = blob.type === 'image/png';
      if (!isValidBuffer) {
        return Promise.reject({ message: 'Received bad data from Converter' });
      }

      let filename = `chart ${id ? `-${id}` : ''}${size.id ? `-${size.id}` : ''}`;
      if (size.id.includes('homepage')) {
        filename += `-${Math.round(size.width * size.scale[idx])}`;
      }
      filename += '.png';

      saveBlob({ blob, filename });
    })
    .catch((err) => {
      console.error(`Image export failed: ${err.message}`);
    });
}

function downloadPng(data, id, size, accessToken, language) {
  return () => {
    const { svg, product } = data;
    let tempProduct = product; // Temporary fix for DJRISKJOURNAL since its note implemented in the endpoint
    if (product === 'djriskjournal') {
      tempProduct = 'wsj';
    }
    if (Array.isArray(svg)) {
      svg.forEach((svgStr, idx) => download(svgStr, product, id, size, idx, accessToken, language));
    } else {
      download(svg, tempProduct, id, size, -1, accessToken, language);
    }
  };
}

function removeGraph(svgString, chartToKeep) {
  const seriesArr = svgString.split('class="highcharts-series ');
  let resultSvg = '';
  seriesArr.forEach((serie, i) => {
    resultSvg += serie;
    if (i !== seriesArr.length - 1) {
      if (i !== chartToKeep) resultSvg += 'display="none" class="highcharts-series ';
      else resultSvg += 'class="highcharts-series ';
    }
  });
  return resultSvg;
}

function handleDownload(svgStr, i, product, size, accessToken, id, language) {
  const removed = removeGraph(svgStr, i);
  const svg = removed || svgStr;
  download(svg, product, id, size, -1, accessToken, language);
}

function downloadMultiplePng(
  data,
  id,
  size,
  series,
  type,
  firstColumnAsCategories,
  accessToken,
  language
) {
  return () => {
    const { svg, product } = data;
    // eslint-disable-next-line no-param-reassign
    if (firstColumnAsCategories) series = series.slice(1);
    for (let i = -1; i < series.length; i++) {
      handleDownload(svg, i, product, size, accessToken, id, language);
    }
  };
}

function exportSvg(data, id, size) {
  return () => {
    const blob = SvgToBlob.convert(data.svg);
    const filename = ['chart', id ? `-${id}` : '', size ? `-${size}` : '', '.svg'].join('');
    saveBlob({ blob, filename });
  };
}

export {
  destroyChart,
  deleteChart,
  updateChartComplete,
  createChartComplete,
  createChartCompleteDuplicate,
  createChart,
  importChart,
  requestChart,
  receiveChart,
  approveChart,
  downloadPng,
  downloadMultiplePng,
  exportSvg,
};
